export class ReportsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async submitMessageReport(params) {
        return this.client.post('/api/reports', params);
    }
    async submitProfileReport(params) {
        return this.client.post('/api/reports', params);
    }
}
//# sourceMappingURL=reports-api.js.map